export let origin = window.location.hostname
export let protocol = window.location.protocol
if (origin === 'localhost' || origin === '127.0.0.1' || origin === 'dev.itti.com.pl') {
  origin = 'dev.itti.com.pl:8016/' /* 'localhost:3001' */
}
import { logOut } from '../../src/components/AdminPanel/module/login.js'

export const getHeaders = () => {
  let bravetoken = localStorage.getItem('bravetoken')
    let tokenDate = parseInt(localStorage.getItem('tokenDate'))
    let braveuser = localStorage.getItem('braveuser')
    let globalHeaders = null
    if (bravetoken && braveuser && (new Date(tokenDate)).getTime() + 21600000 > (new Date()).getTime()) {
      globalHeaders = { headers: { 'Authorization': 'Token ' + bravetoken, responseType: 'blob' } }
      localStorage.setItem('tokenDate', (new Date()).getTime() + 21600000) // 3600000 is 1 hour
    } else {
      logOut()
    }
    return globalHeaders || ''
}



// WEBPACK FOOTER //
// ./src/store/addons.js